import { render } from "./ItemStack.vue?vue&type=template&id=46bccbef"
import script from "./ItemStack.vue?vue&type=script&lang=js"
export * from "./ItemStack.vue?vue&type=script&lang=js"

import "./ItemStack.vue?vue&type=style&index=0&id=46bccbef&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__